import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['content', 'form', 'validationErrorContainer'];

  static values = {
    confirmTitle: String,
    confirmAllow: String,
    confirmCancel: String,
    confirmRemoveAdminMessage: String,
    confirmRemoveMemberManagerMessage: String,
    confirmRemoveContentManagerMessage: String
  };

  connect() {
    document.addEventListener('promote:open-admin-editor', this._openEditor.bind(this));
    document.addEventListener('promote:close-admin-editor', this.closeEditor.bind(this));
  }

  disconnect() {
    document.removeEventListener('promote:open-admin-editor', this._openEditor.bind(this));
    document.removeEventListener('promote:close-admin-editor', this.closeEditor.bind(this));
  }

  formTargetConnected() {
    this.initialRoles = this._getCurrentRoles();

    if (this._validationRequired()) {
      this._getCheckboxes().forEach(checkbox => {
        checkbox.addEventListener('change', this._handleCheckboxChange.bind(this));
      });
    }
  }

  submitForm(event) {
    event.preventDefault();

    const currentRoles = this._getCurrentRoles();

    if (this._validationRequired()) {
      const hasAtLeastOneRole = currentRoles.memberManager || currentRoles.contentManager;

      if (!hasAtLeastOneRole) {
        this._showValidationError();
        return;
      }

      this._hideValidationError();
    }

    if (this.initialRoles) {
      const removingMemberManager = this.initialRoles.memberManager && !currentRoles.memberManager;
      const removingContentManager = this.initialRoles.contentManager && !currentRoles.contentManager;

      if (removingMemberManager || removingContentManager) {
        Rails.confirm(null, event.target, this._confirmationModalDataset(currentRoles), {
          confirmCallback: () => {
            this._submitForm();
          }
        });
        return;
      }
    }

    this._submitForm();
  }

  closeEditor() {
    this.panelEditorController.closePanel();
  }

  get panelEditorController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'panel-editor');
  }

  _openEditor() {
    this.panelEditorController.openPanel();
  }

  _submitForm() {
    const form = this.formTarget;
    const formData = new FormData(form);

    Rails.ajax({
      url: form.action,
      type: form.method,
      data: formData,
      dataType: "script"
    });
  }

  _handleCheckboxChange() {
    if (this._validationRequired()) {
      const currentRoles = this._getCurrentRoles();
      const hasAtLeastOneRole = currentRoles.memberManager || currentRoles.contentManager;

      if (hasAtLeastOneRole) {
        this._hideValidationError();
      }
    }
  }

  _getCheckboxes() {
    return Array.from(this.formTarget.querySelectorAll('input[name="roles[]"]'));
  }

  _validationRequired() {
    return this.initialRoles && !this.initialRoles.memberManager && !this.initialRoles.contentManager;
  }

  _confirmationModalDataset(currentRoles) {
    const removingAllRoles = !currentRoles.memberManager && !currentRoles.contentManager;
    const removingMemberManager = this.initialRoles.memberManager && !currentRoles.memberManager;
    const removingContentManager = this.initialRoles.contentManager && !currentRoles.contentManager;

    let message;
    if (removingAllRoles) {
      message = this.confirmRemoveAdminMessageValue;
    } else if (removingMemberManager) {
      message = this.confirmRemoveMemberManagerMessageValue;
    } else if (removingContentManager) {
      message = this.confirmRemoveContentManagerMessageValue;
    }

    return {
      confirmTitle: this.confirmTitleValue,
      confirmAllow: this.confirmAllowValue,
      confirmCancel: this.confirmCancelValue,
      confirmMessage: message
    };
  }

  _getCurrentRoles() {
    const selectedRoles = Array.from(this.formTarget.querySelectorAll('input[name="roles[]"]:checked'))
      .map(cb => cb.value);

    return {
      memberManager: selectedRoles.includes('program_member_manager'),
      contentManager: selectedRoles.includes('program_content_manager')
    };
  }

  _showValidationError() {
    if (this.hasValidationErrorContainerTarget) {
      this.validationErrorContainerTarget.classList.add('error');
    }
  }

  _hideValidationError() {
    if (this.hasValidationErrorContainerTarget) {
      this.validationErrorContainerTarget.classList.remove('error');
    }
  }
}
